import { createIcon } from '../icons/utils';

/**
 * Legacy ProgressBars' shock glyph: a lightning bolt inside a filled circle.
 *
 * Legacy shipped one file per colour family but all four were byte-identical — the
 * shock glyph is always red, whatever the transmission's clinical priority — so this
 * icon ignores the caller's colour classes and keeps the fixed red from the design
 * tokens.
 */
export const HasShockIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.835 30.67C24.0281 30.67 30.67 24.0281 30.67 15.835C30.67 7.64185 24.0281 1 15.835 1C7.64185 1 1 7.64185 1 15.835C1 24.0281 7.64185 30.67 15.835 30.67Z"
        fill="hsl(var(--themed-red-50))"
        stroke="hsl(var(--themed-red-600))"
        strokeWidth={1.2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9554 16.9036H13.5366V22.9118C13.5366 23.8019 14.6344 24.2172 15.2278 23.5497L21.5475 16.3695C22.0964 15.7464 21.6514 14.7673 20.8206 14.7673H18.2393V8.75916C18.2393 7.86906 17.1416 7.45368 16.5482 8.12126L10.2284 15.3014C9.67954 15.9245 10.1246 16.9036 10.9554 16.9036Z"
        fill="hsl(var(--themed-red-600))"
      />
    </svg>
  ),
  { displayName: 'HasShockIcon', defaultSize: 32, classNameBase: '' },
);
